import {
    Component,
    Optional,
    Inject,
    Input,
    ViewChild,
    AfterViewInit
} from '@angular/core';

import {
    NgModel,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    NG_ASYNC_VALIDATORS,
} from '@angular/forms';

import {ElementBase, animations} from '../';

declare var jQuery: any;
declare var moment: any;

@Component({
    selector: 'itpx-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.css'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: DatePickerComponent,
        multi: true,
    }]
})
export class DatePickerComponent extends ElementBase<string> implements AfterViewInit {
    @Input() public placeholder: string;
    private disabled: boolean;

    public identifier = `itpx-date-picker-${identifier++}`;
    private datepicker;

    @ViewChild(NgModel) model: NgModel;

    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    ) {
        super(validators, asyncValidators);
    }

    ngAfterViewInit() {
        this.datepicker = jQuery('#' + this.identifier).datetimepicker({});
        this.datepicker.on('dp.change', function(event) {
            this.pick(event)
        }.bind(this));
    }

    setDisabledState(isDisabled : boolean) : void {
        this.disabled = isDisabled;
    }

    private pick(event: any) {
        let date = event.date;
        this.value = moment(date).unix();
    }
}

let identifier = 0;


// WEBPACK FOOTER //
// ./src/app/shared/components/controls/date-picker/date-picker.component.ts